import { useCallback } from 'react'
import { v4 } from 'uuid'
import { ThreeEvent } from '@react-three/fiber'

export type FloorplanClickListener = (guid: string, event: ThreeEvent<MouseEvent>) => void

export const floorplanListeners: Map<string, FloorplanClickListener> = new Map()

const useEmitFloorplanClickListener = () => {
  const emit = useCallback((guid: string, event: ThreeEvent<MouseEvent>) => {
    event.stopPropagation()
    Array.from(floorplanListeners.values()).forEach(listener => listener(guid, event))
  }, [])

  return emit
}

export const registerFloorplanClickListener = (listener: FloorplanClickListener) => {
  const id = v4()
  floorplanListeners.set(id, listener)
  return () => {
    floorplanListeners.delete(id)
  }
}

export default useEmitFloorplanClickListener
